import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from 'tss-react/mui';
import {createTheme, ThemeProvider} from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';

const theme = createTheme();
const useStyles = makeStyles()(() => ({
   root: {
      boxShadow: 'none'
   }
}));
/**
 * Barra superior estatica para pantalla principal, el contenido envuelto por este componente aparecera como hijo del componente [Toolbar](https://material-ui.com/api/toolbar/#toolbar-api).
 *
 * Cualquier otra propiedad no especificada en la documentacion sera reenviada al componente [AppBar](https://material-ui.com/api/app-bar/).
 */
const Topbar = React.forwardRef(function Topbar({className, children, ...rest}, ref) {
   const {classes, cx} = useStyles();

   return (
      <AppBar
         ref={ref}
         {...rest}
         className={cx(classes.root, className)}
         color="primary"
         position="fixed"
      >
         <Toolbar>{children}</Toolbar>
      </AppBar>
   );
});

Topbar.propTypes = {
   className: PropTypes.string
};

export default Topbar;
